import { type ReactElement, useEffect } from 'react'
import { useRouter } from 'next/router'
import Head from 'next/head'
import Link from 'next/link'
import { useSnapshot } from 'valtio'
import { APP_CUSTOMERS_PATH } from '../../../../pages/app/customers'
import Breadcrumbs from '../../../../shared/components/ui/breadcrumbs/Breadcrumbs'
import { PageHeading } from '../../../../shared/components/ui/headings/PageHeading'
import { determineBrowserTabName } from '../../../../shared/themes/logoFunctions'
import { customerProxy } from '../../../../shared/proxies/customerProxy'
import {
  executeChildCustomersRetrieve,
  executeCustomerRetrieve,
  executeParentCustomerRetrieve
} from './executeCustomerRetrieve'
import { CustomerMainSection } from './components/CustomerMainSection'
import { CustomerDetailCardDeleteModal } from './modals/CustomerDetailCardDeleteModal'
import { CustomerDetailEditSlideOver } from './modals/CustomerDetailEditSlideOver'

export function CustomerDetail (): ReactElement {
  const router = useRouter()
  const { id } = router.query

  const { customer } = useSnapshot(customerProxy)

  useEffect(() => {
    if (!id) { return }
    void executeCustomerRetrieve(id as string)
  }, [id])

  useEffect(() => {
    if (!customer?.parentCustomerId) { return }
    void executeParentCustomerRetrieve(customer?.parentCustomerId)
  }, [customer])

  useEffect(() => {
    if (!customer?.id) { return }
    void executeChildCustomersRetrieve(customer?.id)
  }, [customer])

  return (
    <>
      <Head>
        <title>{`Customer ${id as string} - ${determineBrowserTabName()}`}</title>
      </Head>
      <CustomerDetailCardDeleteModal />
      <CustomerDetailEditSlideOver />
      <Breadcrumbs breadcrumbs={[{ path: APP_CUSTOMERS_PATH, text: 'Customers' }, { text: (id as string) }]} />
      <PageHeading text="Manage your customers and credit cards" />
      <div className="my-6">
        <Link href={APP_CUSTOMERS_PATH}>
          <div className="underline">
            {'< '}
            Back to Customers
          </div>
        </Link>
      </div>
      <CustomerMainSection />
    </>
  )
}
